import type { GetOptions, GetResult } from '@fingerprint/agent'

export type FingerprintResult = Partial<GetResult> & {
  visitorId?: string
  visitor_id?: string
  requestId?: string
  eventId?: string
  event_id?: string
}

export const getConfig: GetOptions = {
  timeout: 20_000,
  tag:
    typeof document !== 'undefined' && document.referrer !== ''
      ? { referrerLink: document.referrer }
      : { referrerLink: null },
}

export const getConfigExtraTag = (extraTags = {}) => {
  const baseConfig: GetOptions = {
    timeout: 20_000,
    tag: {
      referrerLink: typeof document !== 'undefined' && document.referrer !== '' ? document.referrer : null,
      ...extraTags,
    },
  }

  return baseConfig
}

export const getVisitorId = (data?: FingerprintResult | null) => data?.visitorId ?? data?.visitor_id

export const getRequestId = (data?: FingerprintResult | null) => data?.requestId ?? data?.eventId ?? data?.event_id
